import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './control-label.css';
export var LabelType;
(function (LabelType) {
    LabelType["SECONDARY"] = "secondary";
    LabelType["FORM"] = "form";
})(LabelType || (LabelType = {}));
const classNameByType = {
    [LabelType.SECONDARY]: styles.secondaryLabel,
    [LabelType.FORM]: styles.formLabel
};
export const ControlLabel = ({ children, type = LabelType.SECONDARY, disabled, ...rest }) => (<label className={classNames(styles.label, classNameByType[type], {
        [styles.disabledLabel]: disabled
    })} {...rest}>{children}</label>);
ControlLabel.propTypes = {
    label: PropTypes.node,
    labelStyle: PropTypes.string,
    disabled: PropTypes.bool
};
export default ControlLabel;
